module.exports = __webpack_public_path__ + "src/assets/img/ramblermail.f911afb1.jpg";